<template>
  <div class="personal-info-container">
    <van-popover v-model="showPopover" placement="bottom-end" theme="dark" trigger="click" :actions="actions" @select="handelLogout">
      <template #reference>
        <van-button type="primary">
          <span class="person-icon iconfont iconren"></span>
        </van-button>
      </template>
    </van-popover>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixin from '../../common/mixin'

export default {
  mixins: [mixin],
  components: {
  },
  props: {
    showHomeButton: {
      default: true
    }
  },
  data () {
    return {
      menuList: [
        {
          key: 'SCREENING',
          label: 'Candidate Screening'
        },
        {
          key: 'INTERVIEWS',
          label: 'Candidate Interviews'
        }
      ],
      showPopover: false,
      actions: [
        { text: '' }
      ]
    }
  },
  computed: {
  },
  async created () {
    await this.initHmInfo()
    if (this.hmInfo.name) {
      this.actions[0].text = this.hmInfo.name
    }
    if (this.showHomeButton) {
      this.actions.push({ text: this.$t('hm.btn.homePage'), path: '/v-admin/hm' })
    }
    this.actions.push({ text: this.$t('hm.btn.signOnt'), path: '/v-admin/hm/login?logout=1' })
  },
  beforeDestroy () {

  },
  methods: {
    ...mapActions('hm', ['getHmInfo']),
    // async initHmInfo () {
    //   const resp = await this.getHmInfo()
    //   if (/^[a-zA-Z]+$/.test(resp.last_name)) {
    //     this.actions[0].text = `${resp.first_name} ${resp.last_name}`
    //   } else {
    //     this.actions[0].text = resp.last_name + resp.first_name
    //   }
    // },
    changeExpandStatus () {
      this.showPopover = !this.showPopover
    },
    handelLogout (action) {
      if (action.path) {
        this.$router.push(action.path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-info-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 30px 10px 10px;

  .person-icon {
    font-size: 25px;
  }
  .operate-item:hover{
      cursor:pointer;
      background: #0c0c0c;
    }

  ::v-deep .van-button {
    padding: 0;
    border: 0;
    background-color: unset;
    color: unset;
    height: unset;
  }
}
</style>
